export const MarketingEvents = {
    // Registration
    REGISTRATION_STARTED: 'registration_started',
    REGISTRATION_STEP1_COMPLETED: 'registration_step1_completed',
    REGISTRATION_FORM_COMPLETED: 'registration_form_completed',
    OTP_SENT: 'otp_sent',
    OTP_VERIFIED: 'otp_verified',
    REGISTRATION_COMPLETED: 'registration_completed',
    REGISTRATION_ABANDONED: 'registration_abandoned',
    EMPLOYER_LOGIN: 'employer_login',

    // Job posting
    NEW_JOB_STARTED: 'new_job_started',
    JOB_DETAILS_FILLED: 'job_details_filled',
    JOB_LOCATION_SELECTED: 'job_location_selected',
    JOB_REQUIREMENTS_SET: 'job_requirements_set',
    SALARY_SPECIFIED: 'salary_specified',
    NEW_JOB_PREVIEWED: 'new_job_previewed',
    NEW_JOB_PUBLISHED: 'new_job_published',
    FIRST_JOB_PUBLISHED: 'first_job_published',
    JOB_CLOSED: 'job_closed',
    JOB_REPOSTED: 'job_reposted',

    // Hiring
    APPLICANTS_LIST_VIEWED: 'applicants_list_viewed',
    APPLICANTS_FILTER_APPLIED: 'applicants_filter_applied',
    RECOMMENDED_APPLICANTS_VIEWED: 'recommended_applicants_viewed',
    APPLICANTS_PROFILE_VIEWED: 'applicants_profile_viewed',
    APPLICANTS_VIDEO_VIEWED: 'applicants_video_viewed',
    APPLICANTS_UNLOCKED: 'applicants_unlocked',
    APPLICANTS_SHORTLISTED: 'applicants_shortlisted',
    APPLICANTS_REJECTED: 'applicants_rejected',
    APPLICANTS_CONTACTED_CHAT: 'applicants_contacted_chat',
    APPLICANTS_CALLED: 'applicants_called',
    CV_DOWNLOADED: 'cv_downloaded',
    CV_DATABASE_SEARCHED: 'cv_database_searched',
    AI_INTERVIEW_REQUESTED: 'ai_interview_requested',

    // Paywalls & pricing
    PAYWALL_HIT: 'paywall_hit',
    PAYWALL_PLAN_SELECT: 'paywall_plan_select',
    PAYWALL_QTY_CHANGE: 'paywall_qty_change',
    PAYWALL_CTA_CLICK: 'paywall_cta_click',
    PAYWALL_DISMISS: 'paywall_dismiss',
    PAYWALL_SEE_ALL_PLANS: 'paywall_see_all_plans',
    SAUD_VIDEO_VIEW: 'saud_video_view',
    PRICING_VIEWED_IN_APP: 'pricing_viewed_in_app',

    // Plans page
    PLANS_PAGE_HIT: 'plans_page_hit',
    PLANS_PAGE_SELECT: 'plans_page_select',
    PLANS_PAGE_QTY_CHANGE: 'plans_page_qty_change',
    PLANS_PAGE_CTA_CLICK: 'plans_page_cta_click',
    PLANS_PAGE_DISMISS: 'plans_page_dismiss',

    // PMA only
    PMA_PAYMENT_INTENT: 'pma_payment_intent',

    // Monetization
    PLAN_SELECTED: 'plan_selected',
    SUBSCRIPTION_INITIATED: 'subscription_initiated',
    CHECKOUT_INITIATED: 'checkout_initiated',
    CHECKOUT_LINK_INITIATED: 'checkout_link_initiated',
    PAYMENT_METHOD_SELECTED: 'payment_method_selected',
    PURCHASE_COMPLETED: 'purchase_completed',
    PURCHASE_FAILED: 'purchase_failed',
    SUBSCRIPTION_REPURCHASED: 'subscription_repurchased',
    ENTERPRISE_DEMO_REQUESTED: 'enterprise_demo_requested',
    SUBSCRIPTION_UPGRADE_INITIATED: 'subscription_upgrade_initiated',
    SUBSCRIPTION_UPGRADED: 'subscription_upgraded',

    // Account
    COMPANY_PROFILE_UPDATED: 'company_profile_updated',
    COMPANY_LOGO_UPLOADED: 'company_logo_uploaded',
    COMPANY_LOGO_UPLOAD_FAILED: 'company_logo_upload_failed',
    TEAM_MEMBER_ADDED: 'team_member_added',
    SUPPORT_CHAT_INITIATED: 'support_chat_initiated',
} as const;

export type MarketingEventName = typeof MarketingEvents[keyof typeof MarketingEvents];

/** Job posting, checkout, payment, and subscription events that carry last-touch UTMs. */
export const marketingEventsWithLastUtm: ReadonlySet<string> = new Set([
    MarketingEvents.NEW_JOB_STARTED,
    MarketingEvents.JOB_DETAILS_FILLED,
    MarketingEvents.JOB_LOCATION_SELECTED,
    MarketingEvents.JOB_REQUIREMENTS_SET,
    MarketingEvents.SALARY_SPECIFIED,
    MarketingEvents.NEW_JOB_PREVIEWED,
    MarketingEvents.NEW_JOB_PUBLISHED,
    MarketingEvents.FIRST_JOB_PUBLISHED,
    MarketingEvents.JOB_CLOSED,
    MarketingEvents.JOB_REPOSTED,

    MarketingEvents.PAYWALL_HIT,
    MarketingEvents.PAYWALL_PLAN_SELECT,
    MarketingEvents.PAYWALL_QTY_CHANGE,
    MarketingEvents.PAYWALL_CTA_CLICK,
    MarketingEvents.PAYWALL_DISMISS,
    MarketingEvents.PAYWALL_SEE_ALL_PLANS,
    MarketingEvents.PRICING_VIEWED_IN_APP,

    MarketingEvents.PLANS_PAGE_HIT,
    MarketingEvents.PLANS_PAGE_SELECT,
    MarketingEvents.PLANS_PAGE_QTY_CHANGE,
    MarketingEvents.PLANS_PAGE_CTA_CLICK,
    MarketingEvents.PLANS_PAGE_DISMISS,

    MarketingEvents.PMA_PAYMENT_INTENT,

    MarketingEvents.PLAN_SELECTED,
    MarketingEvents.SUBSCRIPTION_INITIATED,
    MarketingEvents.CHECKOUT_INITIATED,
    MarketingEvents.CHECKOUT_LINK_INITIATED,
    MarketingEvents.PAYMENT_METHOD_SELECTED,
    MarketingEvents.PURCHASE_COMPLETED,
    MarketingEvents.PURCHASE_FAILED,
    MarketingEvents.SUBSCRIPTION_REPURCHASED,
    MarketingEvents.ENTERPRISE_DEMO_REQUESTED,
    MarketingEvents.SUBSCRIPTION_UPGRADE_INITIATED,
    MarketingEvents.SUBSCRIPTION_UPGRADED,
]);
